import { render, staticRenderFns } from "./StaffNotificationActivity.vue?vue&type=template&id=6699d2a2&scoped=true"
import script from "./StaffNotificationActivity.vue?vue&type=script&lang=js"
export * from "./StaffNotificationActivity.vue?vue&type=script&lang=js"
import style0 from "./StaffNotificationActivity.vue?vue&type=style&index=0&id=6699d2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6699d2a2",
  null
  
)

export default component.exports